import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupplierWarehouse } from 'app/profile/models/profile.model';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
	selector: 'dialog-pickup-warehouse-dialog',
	templateUrl: './pickup-warehouse-dialog.component.html',
	styleUrls: ['./pickup-warehouse-dialog.component.scss']
})
export class PickupWarehouseDialogComponent implements OnInit {
	warehouseForm: FormGroup;

	get location() { return this.warehouseForm.get('location'); }
	get address() { return this.warehouseForm.get('address'); }
	get city() { return this.warehouseForm.get('city'); }
	get state() { return this.warehouseForm.get('state'); }
	get zipcode() { return this.warehouseForm.get('zipcode'); }
	get country() { return this.warehouseForm.get('country'); }

	constructor(private fb: FormBuilder,private translate: I18nService,
		public dialogRef: MatDialogRef<PickupWarehouseDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: SupplierWarehouse) {
			this.warehouseForm = this.fb.group({
				location: ['', Validators.required],
				address: ['', Validators.required],
				city: ['', Validators.required],
				state: ['', Validators.required],
				zipcode: ['', Validators.required],
				country: ['', Validators.required]
			});
	}

	ngOnInit() {
		if (this.data.id !== undefined) {
			this.warehouseForm.patchValue({
				location: this.data.locationName,
				address: this.data.address,
				city: this.data.city,
				state: this.data.state,
				zipcode: this.data.zipCode,
				country: this.data.country
			});
        }
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onSave(): void {
		if (this.warehouseForm.invalid) {
			return;
		}
		
        this.data.locationName = this.warehouseForm.value.location;
        this.data.address = this.warehouseForm.value.address;
        this.data.city = this.warehouseForm.value.city;
        this.data.state = this.warehouseForm.value.state;
        this.data.zipCode = this.warehouseForm.value.zipcode;
		this.data.country = this.warehouseForm.value.country;
		this.dialogRef.close(this.data);
	}
}
